import {PostHealthScheduledAppointmentsParams} from 'domain/usecases';
import {makePostHealthScheduledAppointments} from 'main/factories/usecases';

export async function postHealthScheduledAppointments(
	params: PostHealthScheduledAppointmentsParams,
) {
	const response = await makePostHealthScheduledAppointments().post(params);

	return response;
}
